<div class="hb-card card">
    <div class="hb-card-header">
        <h2 class="hb-h3">Slik fungerer Boligkompasset</h2>
    </div>
    <div class="hb-card-body card-content">
        <div>
            <div class="step-icon">
                <hb-badge class="badge" [tone]="'INFO'">1</hb-badge>
                <img src="assets/images/start/sjekkliste.svg" alt="">
            </div>
            <h3 class="hb-h4">Svar på spørsmål</h3>
            <p>Vi stiller enkle spørsmål om nærmiljø, tilgjengelighet og praktiske løsninger.</p>
        </div>
        <div>
            <div class="step-icon">
                <hb-badge class="badge" [tone]="'INFO'">2</hb-badge>
                <img src="assets/images/start/sjekkliste.svg" alt="">
            </div>
            <h3 class="hb-h4">Få anbefalinger</h3>
            <p>Kartlegg boligen din på 5-10 minutter. Vi stiller enkle spørsmål om nærmiljø, tilgjengelighet og
                praktiske løsninger.</p>
        </div>
        <div>
            <div class="step-icon">
                <hb-badge class="badge" [tone]="'INFO'">3</hb-badge>
                <img src="assets/images/start/handlingsplan.svg" alt="">
            </div>
            <h3 class="hb-h4">Handlingsplan</h3>
            <p>Last ned personlig handlingsplan med prioriterte tiltak, kostnadsoversikt og informasjon om
                støtteordninger.</p>
        </div>
    </div>
</div>
